'use strict'

const PropTypes = require('prop-types')
const types = require('../../types')
const React = require('react')

const CommonSupportFormContainer = require('./common-support-form-container')
const GenericInput = require('../inputs/generic')
const Select = require('../inputs/select')
const styles = require('./contact.css')

class SecurityForm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.enableSubmit = this.enableSubmit.bind(this)
    this.isFormDataSelected = this.isFormDataSelected.bind(this)

    const {formData} = props
    this.state = {
      packageAbuseEnabled: this.isFormDataSelected('abuse-or-spam'),
      packageMalwareEnabled: this.isFormDataSelected('malware'),
      packageBugEnabled: this.isFormDataSelected('marketplace-vulnerability'),
      proprietaryBugEnabled: this.isFormDataSelected('proprietary-vulnerability'),
      showSubForm:
        formData.contact &&
        formData.contact['security-inquire'] &&
        ['account', 'abuse-or-spam', 'malware', 'abuse-or-spam'].includes(formData.contact['security-inquire'].value),
    }
  }

  isFormDataSelected(name) {
    if (this.props.formData && this.props.formData.contact && this.props.formData.contact['security-inquire']) {
      return this.props.formData.contact['security-inquire'].value === name
    }
    return false
  }

  enableSubmit(formData) {
    const requiredFields = ['name', 'subject', 'message', 'email']

    if (this.state.packageAbuseEnabled || this.state.packageMalwareEnabled) {
      requiredFields.push('package')
    }
    const emptyField = requiredFields.find(field => {
      return !formData.contact[field] || !formData.contact[field].value
    })
    return !emptyField
  }

  onChange(e) {
    const packageBugEnabled = e.target.value === 'marketplace-vulnerability'
    const proprietaryBugEnabled = e.target.value === 'proprietary-vulnerability'
    const packageAbuseEnabled = e.target.value === 'abuse-or-spam'
    const packageMalwareEnabled = e.target.value === 'malware'
    const showSubForm = ['account', 'abuse-or-spam', 'malware', 'abuse-or-spam'].includes(e.target.value)

    this.setState({
      packageAbuseEnabled,
      packageMalwareEnabled,
      packageBugEnabled,
      proprietaryBugEnabled,
      showSubForm,
    })
  }

  render() {
    const {formData, disableUsernameField, onSubmit, showCaptcha} = this.props

    return (
      <div>
        <Select
          label="My Security Issue"
          formId="contact"
          name="security-inquire"
          formData={formData}
          className="category"
          onChange={this.onChange}
          values={[
            {
              value: 'no-security-issue-selected',
              label: 'Choose one of the following',
            },
            {
              value: 'abuse-or-spam',
              label: 'I am reporting spam or abuse in a package on npmjs.com',
            },
            {
              value: 'malware',
              label: 'I am reporting malware in a package on npmjs.com',
            },
            {
              value: 'proprietary-vulnerability',
              label: 'I have discovered a vulnerability on npmjs.com or the npm CLI',
            },
            {
              value: 'marketplace-vulnerability',
              label: 'I have discovered a bug or vulnerability in a package on npmjs.com',
            },
          ]}
        />
        {this.state.packageBugEnabled && (
          <p className={styles.description}>
            npm support is here to help you with the npm registry itself. If you have found a bug or vulnerability in a
            package on npmjs.com, please contact the package maintainer; you can find their email address by running{' '}
            <code>npm show packagename</code>.
          </p>
        )}
        {this.state.proprietaryBugEnabled && (
          <p className={styles.description}>
            Please submit any vulnerabilities relating to npmjs.com or the npm CLI to the GitHub Bug Bounty program at{' '}
            <a href="https://hackerone.com/github">https://hackerone.com/github</a>.
          </p>
        )}
        {this.state.showSubForm && (
          <div>
            <hr />
            <CommonSupportFormContainer
              onSubmit={onSubmit}
              formData={formData}
              showCaptcha={showCaptcha}
              disableUsernameField={disableUsernameField}
              enableSubmit={this.enableSubmit}
            >
              {(this.state.packageAbuseEnabled || this.state.packageMalwareEnabled) && (
                <div>
                  <GenericInput name="package" label="Package *" formData={formData} required />
                  <GenericInput name="version" label="Version *" formData={formData} required />
                </div>
              )}
            </CommonSupportFormContainer>
          </div>
        )}
      </div>
    )
  }
}

SecurityForm.propTypes = {
  formData: types.formData.isRequired,
  onSubmit: PropTypes.func.isRequired,
  requestPackageDetails: PropTypes.bool,
  disableUsernameField: PropTypes.bool,
  showCaptcha: PropTypes.bool,
}

module.exports = SecurityForm
